import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import HomeScreen from "./components/HomeScreen";
import DashboardPage from "./components/DashboardPage";
import LoginPage from "./components/LoginPage";
import BillingSuccessPage from "./components/BillingSuccessPage";
import ProtectedRoute from "./components/ProtectedRoute";
import TradesPage from "./components/TradesPage";
import CalendarPage from "./components/CalendarPage";
import AIReviewPage from "./components/AIReviewPage";
import GroupsPage from "./components/GroupsPage";
import SettingsPage from "./components/SettingsPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/billing/success" element={<BillingSuccessPage />} />

        <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/trades"    element={<ProtectedRoute><TradesPage /></ProtectedRoute>} />
        <Route path="/calendar"  element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
        <Route path="/ai-review" element={<ProtectedRoute><AIReviewPage /></ProtectedRoute>} />
        <Route path="/groups"    element={<ProtectedRoute><GroupsPage /></ProtectedRoute>} />
        <Route path="/settings"  element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;